import PageNavbar from "@/components/feature/PageNavbar";
import PageFooter from "@/components/feature/PageFooter";

const LAST_UPDATED = "July 13, 2026";

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-black text-white" style={{ fontFamily: "'Space Grotesk', system-ui, sans-serif" }}>
      <PageNavbar />

      <section className="relative w-full overflow-hidden" style={{ padding: "120px 40px 60px" }}>
        <div className="mx-auto" style={{ maxWidth: 1440 }}>
          <div style={{ fontSize: 13, color: "#8A8A8A", letterSpacing: 0.5, textTransform: "uppercase", marginBottom: 20 }}>
            Legal
          </div>
          <h1 style={{ fontSize: "clamp(36px, 5vw, 72px)", fontWeight: 700, letterSpacing: "-0.03em", lineHeight: 1.05, color: "#ECECEC", margin: 0, maxWidth: 900 }}>
            Terms of Use
          </h1>
          <p style={{ fontSize: 15, color: "#8A8A8A", marginTop: 16 }}>
            Last updated: {LAST_UPDATED}
          </p>
        </div>
      </section>

      <div className="mx-auto" style={{ maxWidth: 900, padding: "0 40px 120px" }}>
        <div style={{ fontSize: 15, color: "#8A8A8A", lineHeight: 1.85 }}>
          <Section title="1. Introduction">
            <p style={{ marginBottom: 16 }}>
              Welcome to our website, mobile application, and related services (collectively, the &quot;Service&quot;), operated by Intellivex LTD (&quot;Company&quot;, &quot;we&quot;, &quot;our&quot;, or &quot;us&quot;).
            </p>
            <p style={{ marginBottom: 4, fontWeight: 600, color: "#ECECEC" }}>Registered Address:</p>
            <p style={{ marginBottom: 4 }}>50 Essex Street</p>
            <p style={{ marginBottom: 4 }}>London</p>
            <p style={{ marginBottom: 4 }}>WC2R 3JF</p>
            <p style={{ marginBottom: 16 }}>United Kingdom</p>
            <p style={{ marginBottom: 4 }}>Email: support@inntellivex.com</p>
            <p style={{ marginBottom: 16 }}>Phone: +44 7520 680012</p>
            <p style={{ marginBottom: 16 }}>
              These Terms of Use (&quot;Terms&quot;) govern your access to and use of the Service, including all content, features, functionality, and services made available through it.
            </p>
            <p>
              By accessing or using the Service, you acknowledge that you have read, understood, and agree to be bound by these Terms and our Privacy Policy. If you do not agree with these Terms, please do not access or use the Service.
            </p>
          </Section>

          <Section title="2. Definitions">
            <p style={{ marginBottom: 16 }}>
              &quot;Service&quot; means our website, mobile application(s), and all related features, functionality, and services.
            </p>
            <p style={{ marginBottom: 16 }}>
              &quot;Company&quot; refers to Intellivex LTD.
            </p>
            <p style={{ marginBottom: 16 }}>
              &quot;User&quot;, &quot;you&quot;, or &quot;your&quot; refers to any individual accessing or using the Service.
            </p>
            <p>
              &quot;Content&quot; means all information, text, graphics, software, interfaces, images, and other materials made available through the Service.
            </p>
          </Section>

          <Section title="3. Eligibility">
            <p style={{ marginBottom: 16 }}>By using the Service, you represent and warrant that:</p>
            <ul style={{ listStyle: "disc", paddingLeft: 20 }}>
              <li style={{ marginBottom: 8 }}>You are at least 18 years old or have reached the age of legal majority in your jurisdiction.</li>
              <li style={{ marginBottom: 8 }}>You have the legal capacity to enter into these Terms.</li>
              <li>You will comply with all applicable laws and regulations while using the Service.</li>
            </ul>
          </Section>

          <Section title="4. Acceptable Use">
            <p style={{ marginBottom: 16 }}>
              You agree to use the Service only for lawful purposes and in accordance with these Terms.
            </p>
            <p style={{ marginBottom: 16 }}>You agree not to:</p>
            <ul style={{ listStyle: "disc", paddingLeft: 20 }}>
              <li style={{ marginBottom: 8 }}>Violate any applicable laws or regulations.</li>
              <li style={{ marginBottom: 8 }}>Attempt to gain unauthorized access to any systems, networks, or data.</li>
              <li style={{ marginBottom: 8 }}>Interfere with or disrupt the operation, security, or integrity of the Service.</li>
              <li style={{ marginBottom: 8 }}>Use automated tools, bots, crawlers, or scrapers without our prior written consent.</li>
              <li>Use the Service in any manner that could damage, disable, overburden, or impair the Service or interfere with another user&apos;s experience.</li>
            </ul>
          </Section>

          <Section title="5. Subscriptions and Payments">
            <p style={{ marginBottom: 16 }}>
              Certain features of the Service may require a paid subscription.
            </p>
            <p style={{ marginBottom: 16 }}>For purchases made through the Apple App Store:</p>
            <ul style={{ listStyle: "disc", paddingLeft: 20, marginBottom: 16 }}>
              <li style={{ marginBottom: 8 }}>Payments are processed exclusively by Apple.</li>
              <li style={{ marginBottom: 8 }}>Subscriptions may renew automatically unless canceled before the renewal date.</li>
              <li style={{ marginBottom: 8 }}>You can manage or cancel your subscription at any time through your Apple ID account settings.</li>
              <li>Refund requests are subject to Apple&apos;s refund policies and procedures.</li>
            </ul>
            <p>
              The Company does not process or store payment card information for App Store purchases.
            </p>
          </Section>

          <Section title="6. Intellectual Property">
            <p style={{ marginBottom: 16 }}>
              The Service and all Content are owned by or licensed to the Company and are protected by applicable intellectual property laws.
            </p>
            <p style={{ marginBottom: 16 }}>
              Subject to these Terms, we grant you a limited, non-exclusive, non-transferable, and revocable license to use the Service solely for your personal, non-commercial use.
            </p>
            <p style={{ marginBottom: 16 }}>You may not:</p>
            <ul style={{ listStyle: "disc", paddingLeft: 20 }}>
              <li style={{ marginBottom: 8 }}>Copy, reproduce, distribute, or publicly display any Content without prior written permission.</li>
              <li style={{ marginBottom: 8 }}>Modify, adapt, or create derivative works based on the Service.</li>
              <li>Use our trademarks, logos, branding, or other proprietary materials without authorization.</li>
            </ul>
          </Section>

          <Section title="7. User Content">
            <p style={{ marginBottom: 16 }}>
              If you submit feedback, suggestions, communications, or other content through the Service:
            </p>
            <ul style={{ listStyle: "disc", paddingLeft: 20 }}>
              <li style={{ marginBottom: 8 }}>You retain ownership of your content.</li>
              <li style={{ marginBottom: 8 }}>You grant us a non-exclusive, worldwide, royalty-free license to use such content solely for operating, maintaining, and improving the Service.</li>
              <li>You represent that your content does not infringe the rights of any third party or violate any applicable law.</li>
            </ul>
          </Section>

          <Section title="8. Third-Party Services">
            <p style={{ marginBottom: 16 }}>
              The Service may contain links to or integrations with third-party websites, applications, or services.
            </p>
            <p style={{ marginBottom: 16 }}>We are not responsible for:</p>
            <ul style={{ listStyle: "disc", paddingLeft: 20, marginBottom: 16 }}>
              <li style={{ marginBottom: 8 }}>The availability or functionality of third-party services.</li>
              <li style={{ marginBottom: 8 }}>The content, products, or services provided by third parties.</li>
              <li>Their privacy practices or terms of use.</li>
            </ul>
            <p>
              Your use of third-party services is at your own risk and subject to their own terms and policies.
            </p>
          </Section>

          <Section title="9. Disclaimer">
            <p style={{ marginBottom: 16 }}>
              The Service is provided on an &quot;as is&quot; and &quot;as available&quot; basis.
            </p>
            <p style={{ marginBottom: 16 }}>
              To the fullest extent permitted by law, we make no warranties or representations regarding:
            </p>
            <ul style={{ listStyle: "disc", paddingLeft: 20 }}>
              <li style={{ marginBottom: 8 }}>The accuracy, reliability, or completeness of the Service or its Content.</li>
              <li style={{ marginBottom: 8 }}>Uninterrupted, secure, or error-free operation.</li>
              <li>The Service meeting your specific requirements or expectations.</li>
            </ul>
          </Section>

          <Section title="10. Limitation of Liability">
            <p style={{ marginBottom: 16 }}>
              To the maximum extent permitted by applicable law, the Company shall not be liable for any indirect, incidental, consequential, special, or punitive damages, including loss of profits, data, business opportunities, or goodwill arising from or related to your use of, or inability to use, the Service.
            </p>
            <p>
              Nothing in these Terms excludes or limits liability where such limitation is prohibited by applicable law.
            </p>
          </Section>

          <Section title="11. User Responsibilities">
            <p style={{ marginBottom: 16 }}>You are solely responsible for:</p>
            <ul style={{ listStyle: "disc", paddingLeft: 20 }}>
              <li style={{ marginBottom: 8 }}>Your use of the Service.</li>
              <li style={{ marginBottom: 8 }}>Maintaining the security of your device and account.</li>
              <li>Any activities carried out through your use of the Service.</li>
            </ul>
          </Section>

          <Section title="12. Privacy">
            <p style={{ marginBottom: 16 }}>
              Your use of the Service is also governed by our Privacy Policy.
            </p>
            <p>
              We process personal information in accordance with applicable privacy and data protection laws, including the UK GDPR where applicable.
            </p>
          </Section>

          <Section title="13. Changes to the Service and These Terms">
            <p style={{ marginBottom: 16 }}>
              We reserve the right to modify, suspend, discontinue, or update any part of the Service or these Terms at any time.
            </p>
            <p style={{ marginBottom: 16 }}>
              Any updates become effective upon publication unless otherwise stated.
            </p>
            <p>
              Your continued use of the Service after changes are posted constitutes your acceptance of the revised Terms.
            </p>
          </Section>

          <Section title="14. Suspension and Termination">
            <p style={{ marginBottom: 16 }}>We may suspend, restrict, or terminate your access to the Service at any time if:</p>
            <ul style={{ listStyle: "disc", paddingLeft: 20 }}>
              <li style={{ marginBottom: 8 }}>You violate these Terms.</li>
              <li style={{ marginBottom: 8 }}>We are required to do so by applicable law.</li>
              <li>It is necessary to protect the security, integrity, or operation of the Service or other users.</li>
            </ul>
          </Section>

          <Section title="15. Governing Law">
            These Terms shall be governed by and construed in accordance with the laws of England and Wales, without regard to conflict of law principles.
          </Section>

          <Section title="16. Severability">
            If any provision of these Terms is determined to be unlawful, invalid, or unenforceable, the remaining provisions shall remain in full force and effect.
          </Section>

          <Section title="17. Entire Agreement">
            These Terms, together with our Privacy Policy, constitute the entire agreement between you and the Company regarding your use of the Service and supersede any prior agreements relating to the same subject matter.
          </Section>

          <Section title="18. Contact Us">
            <p style={{ marginBottom: 8 }}>If you have any questions regarding these Terms or the Service, please contact us:</p>
            <p style={{ marginBottom: 4 }}>Intellivex LTD</p>
            <p style={{ marginBottom: 4 }}>50 Essex Street</p>
            <p style={{ marginBottom: 4 }}>London</p>
            <p style={{ marginBottom: 4 }}>WC2R 3JF</p>
            <p style={{ marginBottom: 4 }}>United Kingdom</p>
            <p style={{ marginBottom: 4 }}>Email: support@inntellivex.com</p>
            <p>Phone: +44 7520 680012</p>
          </Section>
        </div>
      </div>

      <PageFooter />
    </div>
  );
}

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div style={{ marginBottom: 48 }}>
      <h2 style={{ fontSize: 22, fontWeight: 600, color: "#ECECEC", letterSpacing: "-0.02em", marginBottom: 16 }}>
        {title}
      </h2>
      <div>{children}</div>
    </div>
  );
}